// extracted by mini-css-extract-plugin
export var blockedMessage = "_a5-3";
export var blockedOverlay = "_a5-1";
export var fadeIn = "_a5-2";
export var hereLink = "_a5-0";
export var slideUp = "_a5-4";